/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The text used in the `<EnvironmentBadge />`.
 * @export
 */
export const MATRIX_ENVIRONMENT_LABELS = {
  development: `Dev`,
  production: `Prod`,
};
